"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryNavigation = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Tooltip_1 = require("../Tooltip/Tooltip");
const NavContainer = Theme_1.styled.div `
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '40px'};
  display: inline-flex;
  background: #ffff;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px #eeeeee solid;
  padding: ${(props) => `0px ${props.horizontalPadding || '64'}px`};
  margin-top: 0px;
  margin-bottom: 0px;
  box-shadow: none;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-weight: 600;
`;
const Tab = Theme_1.styled.div `
  font-family:      ${(props) => props.theme.font.family.proximaNova};
  color:            ${(props) => {
    if (!props.v2) {
        return '#666666';
    }
    return props.isSelected ? '#000' : '#0091EA';
}};
  padding:          ${(props) => props.v2 ? '6px 13px 15px 13px' : '6px 13px 6px 0'};
  min-width:        0;
  font-size:        14px;
  line-height:      17px;
  font-weight:      ${(props) => props.v2 ? '600' : props.isSelected ? '900' : '500'};
  display:          inline;
  letter-spacing    ${(props) => (props.isSelected ? '0' : '-0.08px')};
  border-bottom: ${(props) => {
    if (props.v2) {
        return props.isSelected ? '2px #0091EA solid' : '2px #FFFFFF solid';
    }
    return '0';
}};
  &:hover {
    cursor:         pointer;
    opacity:        ${(props) => (props.v2 ? '0.6' : '1')};
  }
  &:not(:first-of-type) {
    padding:          ${(props) => props.v2 ? '6px 13px 15px 13px' : '6px 13px 6px 13px'};
  }
`;
const Separator = Theme_1.styled.div `
  background-color: ${(props) => props.separatorColor};
  min-width: 0;
  width: ${(props) => `${props.separatorWidth || 0}px`};
  display: inline;
  height: 17px;
`;
const Badge = Theme_1.styled.div `
  background-color: ${(props) => props.badgeColor ? props.badgeColor : '#0091ea'};
  color: #fff;
  font-weight: 700;
  border-radius: ${(props) => (props.isSingleChar ? '50%' : '8px')};
  padding: ${(props) => (props.isSingleChar ? '1px 1px' : '0px 5px')};
  align-items: baseline;
  display: flex;
  justify-content: center;
  min-width: 16px;
  width: auto;
  height: 16px;
  margin-left: 4px;
  margin-right: 4px;
}
`;
const SecondaryNavigation = (props) => {
    const { separatorColor = '#CCCCCC', separatorWidth = 0 } = props;
    const [selectedIndex, setSelectedIndex] = react_1.default.useState(props.startingIndex || 0);
    const changedTab = (index, onClick) => {
        setSelectedIndex(index);
        onClick && onClick();
    };
    return (react_1.default.createElement(NavContainer, Object.assign({}, props), props.tabs.map((item, index) => {
        var _a, _b;
        return (react_1.default.createElement(react_1.default.Fragment, { key: item.title },
            react_1.default.createElement(Tab, { id: `${props.id || 'smr-secondary-navigation'}-element-${index}`, isSelected: index === selectedIndex, onClick: () => changedTab(index, item.onClick), v2: props.v2 },
                item.title,
                ((_a = item.badge) === null || _a === void 0 ? void 0 : _a.content) &&
                    (((_b = item.badge) === null || _b === void 0 ? void 0 : _b.tooltipText) ? (react_1.default.createElement("div", { style: { display: 'inline-block', width: 'auto' } },
                        react_1.default.createElement(Tooltip_1.Tooltip, { title: item.badge.tooltipText, placement: item.badge.tooltipPlacement || 'top' },
                            react_1.default.createElement(Badge, { isSingleChar: item.badge.content.length === 1, badgeColor: item.badge.color }, item.badge.content)))) : (react_1.default.createElement("div", { style: { display: 'inline-block', width: 'auto' } },
                        react_1.default.createElement(Badge, { isSingleChar: item.badge.content.length === 1, badgeColor: item.badge.color }, item.badge.content))))),
            separatorWidth !== 0 && index !== props.tabs.length - 1 && (react_1.default.createElement(Separator, { separatorColor: separatorColor, separatorWidth: separatorWidth }))));
    })));
};
exports.SecondaryNavigation = SecondaryNavigation;
//# sourceMappingURL=SecondaryNavigation.js.map